import { Component, inject } from '@angular/core';
import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { I18nPipe } from '../../shared/i18n/i18n-pipe';
import { I18nScopedService } from '../../shared/i18n/i18n-scoped.service';
import { I18nScopeReadyDirective } from '../../shared/i18n/i18n-scope-ready.directive';
import { provideI18nScope } from '../../shared/i18n/i18n-scope.provider';
import { TabViewService } from '../../shared/tab-view/tab-view.service';
import { TabViewTab } from '../../shared/tab-view/tab-view.model';

/** Browser/VSCode-style tab strip for the experimental tab view (see the `~tabs` dev command). */
@Component({
  selector: 'app-tab-bar',
  imports: [
    MatIconModule,
    MatTooltip,
    I18nPipe,
    I18nScopeReadyDirective,
    CdkDropList,
    CdkDrag,
  ],
  providers: [provideI18nScope('ui/tab-bar'), I18nScopedService],
  templateUrl: './tab-bar.html',
  styleUrl: './tab-bar.scss',
})
export class TabBar {
  protected readonly tabViewService = inject(TabViewService);
  private readonly i18nScoped = inject(I18nScopedService);
  protected readonly tabs = this.tabViewService.tabs;
  protected readonly activeTabId = this.tabViewService.activeTabId;

  protected activate(tabId: string): void {
    this.tabViewService.activateTab(tabId);
  }

  protected close(tabId: string, event: MouseEvent): void {
    event.stopPropagation();
    this.tabViewService.closeTab(tabId);
  }

  protected openNewTab(): void {
    this.tabViewService.openTab('/', this.i18nScoped.t('tab_bar_untitled_tab'));
  }

  protected drop(event: CdkDragDrop<TabViewTab[]>): void {
    this.tabViewService.reorderTabs(event.previousIndex, event.currentIndex);
  }
}
